import { render, staticRenderFns } from "./tabbarSetting.vue?vue&type=template&id=4b136661&scoped=true&"
import script from "./tabbarSetting.vue?vue&type=script&lang=js&"
export * from "./tabbarSetting.vue?vue&type=script&lang=js&"
import style0 from "./tabbarSetting.vue?vue&type=style&index=0&id=4b136661&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b136661",
  null
  
)

export default component.exports